import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

const BYPASS = 'bypass-Cognito';
const SKIP = 'skip-Cognito';

// WHY IS THIS HERE? Because we have multiple services/libs that have cognito headers. And in some cases those libs depends on other libs.
// Our cognito lib has a similiar interceptor that cleans headers, but also has extra logic for adding headers that we dont want. Because we aren't even using cognito in this app.
// So instead of making all those services/libs configurable, it was easiest to clean the headers at root of this app.
@Injectable()
export class CleanCognitoInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const cleanedReq = this.cleanHeaders(request);
    return next.handle(cleanedReq);
  }

  // Deletes extraneous `BYPASS` & `SKIP` header from request to avoid the following error:
  // `Request header bypass-cognito was not present in the Access-Control-Allow-Headers list.`
  cleanHeaders(req: HttpRequest<any>): HttpRequest<any> {
    if (req.headers.get(BYPASS)) {
      req = req.clone({ headers: req.headers.delete(BYPASS) });
    }
    if (req.headers.get(SKIP)) {
      req = req.clone({ headers: req.headers.delete(SKIP) });
    }
    return req;
  }
}
